import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from 'ui/src/components/Theme';

import mobileHeaderCommonTheme from './common';

import mobileHeaderBlogTheme from './_blog';
import mobileHeaderSiteTheme from './_site';

const mobileHeaderThemes = new MatchedMap([
  [ThemeEnum.Blog, mobileHeaderBlogTheme],
  [ThemeEnum.Site, mobileHeaderSiteTheme],
]);

const useMobileHeaderTheme = () => useTheme(mobileHeaderCommonTheme, mobileHeaderThemes);

export default useMobileHeaderTheme;
